import React, { forwardRef } from "react";
import Icon from "./Icon";


const Textfield = forwardRef((props, ref) => {
  return (
    <div className={`ds-textfield ${props.icon && 'icon'} ${props.disabled && 'disabled'}`}>
      {props.icon && <Icon icon={props.icon} />}

      <input
        ref={ref}
        type={props.type ? props.type : 'text'}
        placeholder={props.placeholder}
        value={props.value}
        defaultValue={props.default}
        onFocus={props.onfocus}
        onBlur={props.onblur}
        onChange={props.onChange}
        readOnly={props.readOnly && true}
      />
    </div>
  )
});

export default Textfield;


/*

Usage:

<Textfield icon="" type="" placeholder="" value="" default="" onfocus={} readonly={} disabled={} />

- icon (Optional): Figma Icon Name in format "icon-name"
- type (Optional): Input type
- placeholder (Optional): String
- value (Optional): String
- default (Optional): String
- onfocus (Optional): Function
- onblur (Optional): Function
- readonly (Optional): Bool
- disabled (Optional): Bool

*/
